// extracted by mini-css-extract-plugin
module.exports = {"bounder":"_3HLDU","list":"_312aG"};